/**
 * @module Phrases
 * Allows to randomly pick a funny phrase for comments stubs
 * Implemented as singleton (@TODO: remake to a class?)
 */

const extend = require('xtend/mutable');
const sample = require('lodash/sample');

const phrases = {
  ru: [
    '«Лучше своевременно сказанное одно слово, чем не вовремя – тысячи»',
    '«Люди запутываются в массе лишних слов»',
    '«Меньше слов – меньше корректив»',
    '«Невысказанные слова – трофеи тишины»',
    '«Одно отмеренное слово лучше тысяч не отмеренных»',
    '«Играя на словах, главное – не сбиться с чувства такта»',
    '«Не сказать неизречимое больше благо, чем сказать изречимое»',
    '«Слова, в которых нет смысла, и нет дела - утомляют и опустошают»',
    '«Чтобы не надо было сдерживать слово, надо его сдержать»',
    '«Краткость – сестра таланта»',
    '«Бросьте пустые слова!»',
  ],
  /** @ref https://www.englishclub.com/ref/Sayings/Talking/ */
  en: [
    '“A still tongue makes a wise head”',
    '“A word to the wise is enough”',
    '“Better the foot slip than the tongue”',
    '“Silence is golden”',
    '“Speech is silver, silence is golden”',
    '“There is a time to speak and a time to be silent”',
  ],
};

const authors = {
  ru: [
    'Известный писатель',
    'Джон Смит',
    'Предположиельно Сократ, но неточно',
    'Польский мыслитель',
    'Знакомый через 3 рукопожатия',
    'Один из ваших знакомых',
    'Человек напротив вас',
    'Ваш психолог',
    'Экзистенциальный философ',
    'Силэндский шпион',
    'Его величество',
  ],
  en: [
    'His majesty',
    'The man in front of you',
  ],
};

// eslint-disable-next-line no-multi-assign
const exports = module.exports = {};

extend(exports, {
  settings: {
    lang: 'ru',
  },
  phrases,
  authors,
  setLocale(val) {
    if (phrases[val]) exports.settings.lang = val;
  },
  getRandomPhrase() {
    return sample(phrases[exports.settings.lang]);
  },
  getRandomAuthor() {
    return sample(authors[exports.settings.lang]);
  },
});
